export const STATUS_DEFAULT = {
    restricted: false,
    archive: false
};

export enum Status {
    Archive = "archive",
    Restricted = "restricted"
}

export class LokiOrganizationDialogBaseController {
    public static $inject: string[] = [
        "$mdDialog",
        "$translate"
    ];

    public $t;
    public status: string;

    constructor(
        protected $mdDialog: ng.material.IDialogService,
        $translate: ng.translate.ITranslateService
    ) {
        this.$t = $translate.instant;
    }

    public close() {
        this.$mdDialog.cancel();
    }
}
